import type { ApiEnvironment } from 'src/shared/utils/environment';

export enum DesignerProductProvider {
  PELLA = 'pella',
  GAF = 'GAF',
  HARDIE = 'hardie',
  GENERIC = 'generic',
}

export enum MaterialCalloutType {
  SHOP = 'shop',
  APPOINTMENT = 'appointment',
  QUOTE = 'quote',
  NONE = 'none',
}

type DesignerProviderOrgIds = { [OrgId: string]: DesignerProductProvider };

export const DESIGNER_PRODUCT_PROVIDER_MAP: Record<
  ApiEnvironment,
  DesignerProviderOrgIds | null
> = {
  production: {
    '2cdd9d42-b418-40bf-a762-b523cbd8d4dd': DesignerProductProvider.PELLA,
    '16d16121-43f5-4a07-97e8-c931b1daaabf': DesignerProductProvider.GAF,
    '81d08ac7-f06d-49ac-a01b-e2250e4ec261': DesignerProductProvider.HARDIE,
    '76dc28fb-f02c-48f1-8ab1-84dab21ad752': DesignerProductProvider.GENERIC,
  },
  staging: {
    '2cdd9d42-b418-40bf-a762-b523cbd8d4dd': DesignerProductProvider.PELLA,
    '69d8edb2-26f0-49fd-a249-91b00d0ecbd5': DesignerProductProvider.GAF,
    '0ea75b19-216f-41a1-8a31-f8524c1e2e84': DesignerProductProvider.HARDIE,
    '76dc28fb-f02c-48f1-8ab1-84dab21ad752': DesignerProductProvider.GENERIC,
  },
  sandbox: null,
  mock: null,
} as const;

export const PELLA_MANUFACTURER_UUID =
  Object.entries(DESIGNER_PRODUCT_PROVIDER_MAP.production || {}).find(
    ([_, value]) => value === DesignerProductProvider.PELLA,
  )?.[0] || '';
